export default __webpack_public_path__ + "static/media/trash.3b106fc6.svg";